import {
  initialState,
  Actions,
  State,
  MIGRATE_ENTITY,
  MIGRATE_ENTITY_SUCCESS,
  MIGRATE_ENTITY_ERROR,
  RESET_MIGRATE_ENTITY,
} from '../../types/enargas/migrate-entity'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case MIGRATE_ENTITY:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case MIGRATE_ENTITY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case MIGRATE_ENTITY_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_MIGRATE_ENTITY:
      return initialState
    default:
      return state
  }
}

export default reducers
